// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__201iw","container":"styles_container__3llCm","title":"styles_title__3j-IC","wrapper":"styles_wrapper__us1A5","answer":"styles_answer__5lr_t"};